import { REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT } from '../../constants/key'
import getByProfileIdDataPeriodDomainListPathReduxUtil from '../get-by-profile-id-data-period-domain-list-path'

export default function getByProfileIdDataPeriodDomainListPathsReduxUtil ({
  instance,
  date,
  state
}) {
  return Object
    .values(REDUX_DOMAIN_LIST_DATE_PERIOD_UNIT)
    .map(datePeriodUnit => {
      return getByProfileIdDataPeriodDomainListPathReduxUtil({
        instance,
        datePeriodUnit,
        date,
        state
      })
    })
}
